import React from 'react'
import PageHeader from '../components/PageHeader'
import PageContent from '../components/PageContent'
import TableComponent from '../components/TableComponent';
import pdf1 from "../assets/College.pdf"
import pdf2 from "../assets/Overall.pdf"


function RankingNirf() {
    const thead = ['S.No','Topic', 'File'];
const tbody = [
    {
      id:1,
      title:"College Level Data Submitted for NIRF Rankings 2026",
      file:pdf1
    },
     {
      id:2,
      title:"Overall Data Submitted for NIRF Rankings 2026",
      file:pdf2
    }

     
];


  return (
    <div> 
      <PageHeader title="NIRF" />
             <div className='contentarea' style={{background:"white"}}>
        
          <div className='sub-contentarea' style={{boxShadow:"none",padding:"none"}}>
            <div>
              
              <table>
                <thead>
                  <tr>
                    <th>SR NO.</th>
                    <th>Title</th>
                    <th>Link</th>
                  </tr>
                </thead>
                <tbody style={{ textTransform: "uppercase" }}>
                  <tr>
                    <td>1</td>
                    <td> College Level Data Submitted for NIRF Rankings 2026</td>
                    <td>
                      <a target="_blank" href={pdf1}>Get Document</a>
                    </td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td> 	Overall Data Submitted for NIRF Rankings 2026</td>
                    <td>
                      <a target="_blank" href={pdf2}>Get Document</a>
                    </td>
                  </tr>
                  
                </tbody>
              </table>
            </div>
          </div>
        </div>

    </div>
  )
}

export default RankingNirf
